export enum EnumRoute {
  About = 'About',
  Blog = 'Blog',
  BlogPost = 'BlogPost',
  Sitemap = 'Sitemap',
  RedirectSitemapXml = 'RedirectSitemapXml',
  RedirectBlog = 'RedirectBlog',
  RedirectAbout = 'RedirectAbout',
}
